import React from "react";

export default function OrderModePopup({ onSelect }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <h2>Choose Order Mode</h2>
        <p>Please select how you want to place your order:</p>

        <div className="popup-actions">
          <button onClick={() => onSelect("online")}>
            Order Online
            <br />
            <small>Self-service ordering through our website.</small>
          </button>

          <button onClick={() => onSelect("shop")}>
            Get Help In-Store
            <br />
            <small>Visit us for assistance and place your order with our team.</small>
          </button>
        </div>
      </div>
    </div>
  );
}